import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GenericStatusCodeResponse } from './generic-response.model';
import { CommunicationMethod } from './preference-center.model';

Injectable();

export class PreferenceCenterService {
  private httpService = inject(HttpClient);

  /* Returns order and details for communication categories from CMS */
  public getCmsCommunicationDetails(): Observable<any[]> {
    const preferenceCenterOrderEndPoint = '/cms/api/v2/preference-center-order';

    return this.httpService.get<any[]>(preferenceCenterOrderEndPoint);
  }

  /* Returns a list of communication methods from notification manager */
  public getCommunicationMethods(
    refresh: boolean
  ): Observable<CommunicationMethod[]> {
    const params = new HttpParams().append('refresh', `${refresh}`);
    const communicationMethodsEndPoint =
      '/api/v1/notificationManager/communicationMethods';

    return this.httpService
      .get<GenericStatusCodeResponse<CommunicationMethod[]>>(
        communicationMethodsEndPoint,
        { params: params }
      )
      .pipe(map((x: any) => x.data));
  }

  /* Creates a new preference profile for a email address in CDH */
  public createPreferenceProfile(body: any): Observable<any> {
    const preferenceProfileEndPoint = '/api/v2/preferences/preference-profile';
    return this.httpService.post<any>(preferenceProfileEndPoint, body);
  }
}
